import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteIssueVisibilityRequest = {
	sonarObjectId: number;
};

export const deleteIssueVisibility = createDeleteEndpoint<DeleteIssueVisibilityRequest>(
	(request) => `/api/v3/core/sonar-objects/issues/${request.sonarObjectId}/visibility`
);
